export const CUSTOM_THEME = {
    'common.minHeight': '0',
    'common.holiday.color': '#333',
    // month header 'dayname'
    'month.dayname.height': '42px',
    'month.dayname.borderLeft': '1px solid #ddd',
    'month.dayname.paddingLeft': '8px',
    'month.dayname.paddingRight': '0',
    'month.dayname.fontSize': '13px',
    'month.dayname.backgroundColor': 'inherit',
    'month.dayname.fontWeight': 'normal',
    'month.dayname.textAlign': 'left',

    // month day grid cell 'day'
    'month.holidayExceptThisMonth.color': '#333',
    'month.dayExceptThisMonth.color': '#bbb',
    'month.weekend.backgroundColor': '#fafafa',
    'month.day.fontSize': '16px',

    // month schedule style
    'month.schedule.borderRadius': '5px',
    'month.schedule.height': '20px',
    'month.schedule.lineHeight': '20px',
    'month.schedule.marginTop': '2px',
    'month.schedule.marginLeft': '10px',
    'month.schedule.marginRight': '10px',

    // week header 'dayname'
    'week.dayname.height': '41px',
    'week.dayname.borderTop': '1px solid #ddd',
    'week.dayname.borderBottom': '1px solid #ddd',
    'week.dayname.borderLeft': '1px solid #ddd',
    'week.dayname.paddingLeft': '5px',
    'week.dayname.backgroundColor': 'inherit',
    'week.dayname.textAlign': 'left',
    'week.today.color': '#333',
    'week.pastDay.color': '#333',

    // week vertical panel 'vpanel'
    'week.vpanelSplitter.border': '1px solid #ddd',
    'week.vpanelSplitter.height': '3px',

    // week daygrid 'daygrid'
    'week.daygrid.borderRight': '1px solid #ddd',
    'week.daygrid.backgroundColor': 'inherit',

    'week.daygridLeft.width': '77px',
    'week.daygridLeft.backgroundColor': '#a8def74d',
    'week.daygridLeft.paddingRight': '5px',
    'week.daygridLeft.borderRight': '1px solid #ddd',

    'week.today.backgroundColor': 'inherit',
    'week.weekend.backgroundColor': 'inherit',

    // week timegrid 'timegrid'
    'week.timegridLeft.width': '77px',
    'week.timegridLeft.backgroundColor': '#03a9f44d',
    'week.timegridLeft.borderRight': '1px solid #ddd',
    'week.timegridLeft.fontSize': '12px',
    'week.timegridLeftTimezoneLabel.height': '51px',
    'week.timegridLeftAdditionalTimezone.backgroundColor': '#fdfdfd',

    'week.timegridOneHour.height': '48px',
    'week.timegridHalfHour.height': '24px',
    'week.timegridHalfHour.borderBottom': '1px dotted #f9f9f9',
    'week.timegridHorizontalLine.borderBottom': '1px solid #eee',

    'week.timegrid.paddingRight': '10px',
    'week.timegrid.borderRight': '1px solid #ddd',
    'week.timegridSchedule.borderRadius': '0',
    'week.timegridSchedule.paddingLeft': '0',

    'week.currentTime.color': '#135de6',
    'week.currentTime.fontSize': '12px',
    'week.currentTime.fontWeight': 'bold',

    'week.pastTime.color': '#333',
    'week.pastTime.fontWeight': 'normal',

    'week.futureTime.color': '#333',
    'week.futureTime.fontWeight': 'normal',

    'week.currentTimeLinePast.border': '1px solid rgba(19, 93, 230, 0.3)',
    'week.currentTimeLineBullet.backgroundColor': '#135de6',
    'week.currentTimeLineToday.border': '1px solid #135de6',
    'week.currentTimeLineFuture.border': '1px solid #135de6',

    // week daygrid schedule style
    'week.dayGridSchedule.borderRadius': '0',
    'week.dayGridSchedule.height': '18px',
    'week.dayGridSchedule.marginTop': '2px',
    'week.dayGridSchedule.marginLeft': '10px',
    'week.dayGridSchedule.marginRight': '10px',

};

export const CalendarStyles = (theme) => {
    return {
        header: {
            margin: '0 0 10px 0'
        },
        emptyChip: {
            marginRight: '7px'
        },
        myShiftChip: {
            backgroundColor: '#0A54A2',
            marginRight: '7px'
        },
        myTradeChip: {
            backgroundColor: '#fff000',
            marginRight: '7px'
        },
        availableOfferChip: {
            backgroundColor: '#48D960',
            marginRight: '7px'
        },
        myRequestChip: {
            backgroundColor: '#6f0880',
            marginRight: '7px'
        },
        myPendingOffer: {
            backgroundColor: 'rgba(255, 200, 0, 1)',
            marginRight: '7px'
        },
        shiftAvailableToCoverChip: {
            backgroundColor: '#48D960',
            marginRight: '7px'
        },
        activeView: {
            color: '#FFFFFF !important',
            backgroundColor: '#0A54A2',
            border: '1px solid #0A54A2 !important',
            '&:hover': {
                color: '#FFFFFF !important',
                backgroundColor: '#0A54A2',
                border: '1px solid #0A54A2 !important',
            }
        },
        flex: {
            display: 'flex',
        },
        button: {
            color: '#3A3A3A',
            border: '1px solid #E6EDF5',
            borderRadius: 2,
            marginRight: 5,
            marginLeft: 5,
            paddingLeft: 10,
            paddingRight: 10,
        },
        myShiftButton: {
            border: '0px',
            borderRadius: 2,
            marginRight: 5,
            marginLeft: 5,
            paddingleft: 10,
            paddingright: 10,
            '&.MuiButton-root:hover': {
                backgroundColor: 'transparent',
            }
        },
        arrowButton: {
            minWidth: 0,
            width: 30,
            height: 30,
        },
        refreshButton: {
            minWidth: 0,
            padding: 11,
        },
        historyHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 15,
            paddingBottom: 5,
            marginBottom: 15,
            borderBottom: '1px solid rgb(230, 237, 245)',

        },
        SearchInput: {
            padding: '0 16px',
            marginBottom: 24,
        },
        historyItemContainer: {
            margin: '12px 16px',
            minWidth: 280
        },
        historyLogFirst: {
            fontSize: '14px'
        },
        historyLogName: {
            fontWeight: 'bold',
            wordWrap: 'break-word',
        },
        historyLogshiftTime: {
            textDecoration: 'underline'
        },
        historyLogDate: {
            fontSize: '12px',
            color: '#878787'
        }
    }
};

export const ManagerDashboardStyles = (theme) => {
    return {
        navTitle: {
            fontSize: '19px',
            fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: '700',
            flexGrow: 1,
        },
        mainContent: {
            margin: 'auto'
        },
        fullPage: {
            // marginTop: auto,
            margin: 'auto',
            backgroundColor: '#FFFFFF'
        },
        topGrid: {
            paddingTop: '10px'
        },
        table: {
            height: '400px',
            padding: '1px'

        },
        ButtonAction: {
            width: '100%',
            borderColor: '#E6EDF5',
            '&:disabled': {
                border: 0
            }
        },
        drpButton: {
            border: '1px solid #E6EDF5',
            width: '100%',
            padding: '7px',
            margin: '5px 5px 5px 0px',
            display: 'block',
            '&.Mui-disabled': {
                backgroundColor: 'hsl(0, 0%, 95%)'
            },
        },
        drp: {
            width: '100%',
            display: 'block',
            '& .Mui-disabled': {
                backgroundColor: 'hsl(0, 0%, 95%)'
            },
        },
        clipboardListIcon: {
            color: '#0A54A2',
            margin: '0 6px',
        },
        calendarIcon: {
            color: '#357ebd',
            marginLeft: '6px',
            marginRight: '10px'
        },
        chevronIcon: {
            marginLeft: '7px',
            color: '#357ebd',
            marginRight: '10px'
        },
        periodLabel: {
            color: theme.colors.secondary[400],
            textTransform: 'Capitalize',
            fontSize: '0.75em'
        },
        subHeader: {
            color: '#878787 !important',
            margin: '10px',
        },
        periodSelect: {
            flex: 1,
            color: '#878787',
            fontSize: 12,
        },
        hyperfindSelect: {
            flex: 1,
            color: '#878787',
            fontSize: 12,
        },
        searchBar: {
            color: '#878787',
            border: '1px solid #CCCCCC',
            height: '56px',
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: 'none',
        },
        searchBarText: {
            marginLeft: theme.spacing(1),
            flex: 1,
            fontSize: 16,
            padding: 3,
            margin: 5,
        },
        searchBarIcon: {
            color: '#878787',
            padding: 3,
            margin: 5,
        },
        divider: {
            height: 28,
            margin: 4,
            backgroundColor: '#CCCCCC',
        },
        moreOptionsContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
        moreOptionsBox: {
            color: '#3A3A3A',
            textAlign: 'right'
        },
        moreOptionsButton: {
            textAlign: 'right',
            color: '#3A3A3A',
            border: '1px solid #CCCCCC',
            margin: 7,
            padding: 14,
            fontSize: '18px'
        },
        buttonCancel: {
            marginRight: "10px",
            minWidth: "100px",
            color: '#1a518a',
            marginLeft: '15px',
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            border: '1px solid #E6EDF5',
            borderRadius: '5px',
            opacity: '1',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: '#EEEEEE',
                opacity: '70%'
            }
        },
        buttonSubmit: {
            minWidth: "100px",
            color: '#FFFFFF',
            backgroundColor: '#1a518a',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '5px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: 'rgb(18,56,96)',
                opacity: '70%'
            }
        },
        filterPanel: {
            minWidth: "600px",
            height: "100vh",
            backgroundColor: "#FAFAFA",
            border: "1px solid #E6EDF5",
        },
        filterPanelHeader: {
            backgroundColor: '#FFFFFF',
            borderBottom: "1px solid #CCCCCC",
            padding: "10px",
        },
        filterPanelHeaderText: {
            font: "Bold 18px/21px Montserrat",
            letterSpacing: "0px",
            color: "#3A3A3A",
            textAlign: "left",
            fontSize: "22px",
            fontWeight: "bold",
            lineHeight: "32px",
        },
        filterPanelTabs: {
            backgroundColor: '#FFFFFF',
            borderBottom: "1px solid #CCCCCC",
            padding: "0px 10px",
        },
        filterPanelTab: {
            font: "Bold 18px/21px Montserrat",
            fontSize: "20px",
            lineHeight: "22px",
            fontWeight: "bold",
            padding: "10px 5px",
            textAlign: "center",
            cursor: "pointer",
            '&:hover': {
                backgroundColor: '#FCFCFC',
                opacity: '70%'
            }
        },
        filterPanelTabSelected: {
            font: "Bold 18px/21px Montserrat",
            fontSize: "20px",
            lineHeight: "22px",
            fontWeight: "bold",
            color: "#0A54A2",
            borderBottom: "2px solid #0A54A2",
            padding: "10px 5px",
            textAlign: "center",
            cursor: "pointer",
            '&:hover': {
                backgroundColor: '#FCFCFC',
                opacity: '70%'
            }
        },
        filterPanelSelectionBox: {
            fontSize: "13px",
            fontWeight: "bold",
            margin: "20px",
            border: "1px solid #E6EDF5",
            backgroundColor: "#FFFFFF",
            borderRadius: "5px",
            padding: "10px",
        },
        iconFixHeight: {
            height: "24px"
        },
        alignStack: {
            display: 'block'
        },
        labelButtons: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: 14,
            textTransform: 'capitalize',
            fontWeight: 500
        },
        buttonApply: {
            minWidth: "100px",
            color: '#FFFFFF',
            backgroundColor: '#0A54A2',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '4px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
            '&:hover': {
                backgroundColor: '#2265AB'
            },
            margin: '10px 3px 10px 5px',
            height: '46px'
        },
    }
}

export const ManagerTableViewStyles = (theme) => {
    return {
        faExclamationTriangle: {
            color: '#F46F6F',
        },
        transparentButton: {
            textTransform: 'none',
            padding: '0px',
            width: '95%',
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '&:active': {
                backgroundColor: 'transparent'
            },
            display: 'inline',
            textAlign: 'left',
            "padding-left": '20px',
        },
        buttonAddMore: {
            minWidth: "100px",
            color: '#FFFFFF',
            backgroundColor: '#0A54A2',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '4px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: '#2265AB'
            },
            marginTop: '5px',
            marginBottom: '10px'
        },
        labelButtons: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: 14,
            textTransform: 'capitalize',
            fontWeight: 500
        },
        labelViews: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: 14,
            fontWeight: 300,
            marginTop: '5px'
        },
        buttonApply: {
            minWidth: "100px",
            color: '#FFFFFF',
            backgroundColor: '#0A54A2',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '4px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
            '&:hover': {
                backgroundColor: '#2265AB'
            },
            margin: '10px 3px 10px 5px',
            height: '46px'
        },
        buttonClear: {
            minWidth: "100px",
            color: '#000000',
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '4px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: '#FFFFFF',
                opacity: '70%'
            },
            margin: '10px 0px',
            height: '46px'
        },
        labelNumberOfRows: {
            marginLeft: 5,
            color: '#878787',
            flex: 1,
            fontSize: 12,
        },
        transparentButtonNoPadding: {
            textTransform: 'none',
            padding: '0px',
            width: '100%',
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '&:active': {
                backgroundColor: 'transparent'
            },
            display: 'inline',
            textAlign: 'left',
        },
        blue: {
            backgroundColor: 'blue'
        },
        chipFormatting: {
            fontSize: '13px',
            fontWeight: 'bold',
            color: '#0A54A2',
            borderRadius: '0px',
            backgroundColor: '#D4E0EC',
        },
        chipTC: {
            fontSize: '13px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: 'rgba(255,224,0,0.16)',
            color: '#6c757d',
            textShadow: '1px 1px #DADADA'
        },
        chipSS: {
            fontSize: '13px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: 'rgba(255,124,87,0.16)',
            color: '#FF7A59',
        },
        chipOS: {
            fontSize: '13px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: 'rgba(236,12,12,0.16)',
            color: '#EE0F0F',
        },
        chipVTO: {
            fontSize: '13px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: '#c4ecc4',
            color: '#006600',
        },
        fixPadding: {
            padding: '2px 10px',
            '&:last-child': {
                paddingBottom: '0',
            },
            display: 'flex',
            justifyContent: 'space-between',
        },
        shiftTimeText: {
            fontSize: '12px',
            textAlign: 'left',
            letterSpacing: '0px',
            fontWeight: 'bold',
        },
        shiftTimeTextLarge: {
            fontSize: '16px',
            textAlign: 'left',
            letterSpacing: '0px',
        },
        primaryJobText: {
            fontSize: '12px',
            textAlign: 'left',
            letterSpacing: '0px',
        },
        employeeNameText: {
            fontSize: '16px',
            whiteSpace: 'nowrap',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            color: '#3A3A3A',
            letterSpacing: '0',
            textAlign: 'left',
        },
        TCShiftCard: {
            width: '100%',
            borderLeft: '4px solid #0A54A2'
        },
        SSShiftCard: {
            width: '100%',
            borderLeft: '4px solid #0A54A2'
        },
        OSShiftCard: {
            width: '100%',
            borderLeft: '4px solid #EE0F0F'
        },
        VTOShiftCard: {
            width: '100%',
            borderLeft: '4px solid #006600'
        },
        OSShiftCardApproved: {
            width: '100%',
            borderLeft: '4px solid #0A54A2'
        },
        VTOShiftCardApproved: {
            width: '100%',
            borderLeft: '4px solid #0A54A2'
        },
        employeeShiftCard: {
            width: '100%',
            borderLeft: '4px solid #0A54A2'
        },
        dataviewShiftCard: {
            width: '100%',
            borderLeft: '4px solid #0A54A2'
        },
        table: {
            height: '100%'
        },
        tableHeader: {
            boxShadow: '0 0 0 1px #333'
        },
        tableHeaderCell: {
            fontWeight: 600,
            fontSize: 14
        },
        detailPanel: {
            backgroundColor: '#e4eaf0',
            alignItems: 'center',
            padding: 5,
        },
        infoLabel: {
            fontWeight: 600,
            color: '#333'
        },
        detailPanelShift: {
            marginBottom: 5,
        },
        divider: {
            margin: theme.spacing(1)
        },
        employeeTrade: {
            fontSize: 16
        },
        tradeIcon: {
            color: 'rgba(135, 135, 135, 1)',
            fontSize: 16
        },
        employeeNameDetail: {
            fontWeight: 600,
        },
        warningMessage: {
            borderBottom: "1px dotted lightgray",
            fontSize: 14,
            margin: "2px",
            paddingBottom: "10px",
            paddingTop: "10px",
            lineHeight: "20px",
            whiteSpace: "pre-wrap",
            '&:last-child': {
                borderBottom: "none",
            },
        },
        selectWrapper: {
            marginBottom: 0,
        },
        select: {
            width: '100%',
            height: '50px',
            zIndex: 1301,
        },
        dataviewPanel: {
            padding: '5px 20px',
            backgroundColor: '#FFFFFF',
        },
        dataviewTableGroup: {
            border: "1px solid lightgray",
            marginTop: "10px",
            borderRadius: "5px",
        },
        dataviewTableGroupHeaderShift: {
            display: "inline-block",
            verticalAlign: "top",
            marginTop: "15px"
        },
        dataviewTableSegmentInfos: {
            lineHeight: "8px",
            marginLeft: "38px",
            verticalAlign: "text-top",
            display: "inline-block"
        },
        dataviewTableRecalculateAwarding: {
            float: "right",
            display: 'flex',
            width: '-webkit-fill-available',
            justifyContent: 'flex-end',
            marginTop: '0px'
        },
        dataviewTableToggleButton: {
            margin: "10px",
            marginBottom: "0px",
        },
        dataviewTableGroupHeader: {
            display: 'flex',
        },
        SideBarTitle:
        {
            fontSize: '16px',
            fontFamily: 'Montserrat, Regular',
            letterSpacing: '0',
            color: '#3A3A3A',
            opacity: '1',
            fontWeight: 'bold',
            textAlign: 'left',
        },
    }
}

export const EmployeeDashboardStyles = (theme) => {
    return {

        appName: {
            width: 320,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 15,
        },
        topBar: {
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: 'calc(100% - 585px)',
            minWidth: 450
        },
        fullPage: {
            width: '100vw',
            height: 'calc(100vh - 65px)',
            marginTop: 65,
            minWidth: 1000,
            backgroundColor: '#FFFFFF'
        },
        drpButton: {
            border: '1px solid #E6EDF5',
            width: '100%',
            padding: '7px',
            margin: '5px 5px 5px 0px',
            display: 'block',
            '&.Mui-disabled': {
                backgroundColor: 'hsl(0, 0%, 95%)'
            },
        },
        drp: {
            width: '100%',
            display: 'block',
            '& .Mui-disabled': {
                backgroundColor: 'hsl(0, 0%, 95%)'
            },
        },
        calendarIcon: {
            color: '#357ebd',
            marginLeft: '6px',
            marginRight: '10px'
        },
        chevronIcon: {
            marginLeft: '7px',
            color: '#357ebd',
            marginRight: '10px'
        },
        periodLabel: {
            color: theme.colors.secondary[400],
            textTransform: 'Capitalize',
            fontSize: '0.75em'
        },
        subHeader: {
            color: '#878787 !important',
            margin: '10px',
        },
        detailPanel: {
            backgroundColor: '#FCFCFC',
            alignItems: 'center',
            padding: '10px',
            width: '100%',
        },
        detailPanelSegment: {
            marginBottom: 5,
        },
        shiftInfoHeader: {
            fontFamily: 'Roboto',
            fontSize: '1.25rem',
            fontWeight: '700',
            paddingLeft: 8,
        },
        shiftInfoHeaderEmployeeNameWrapper: {
            display: 'flex',
            alignItems: 'center'
        },
        shiftInfoHeaderEmployeeName: {
            fontFamily: 'Roboto',
            fontSize: '0.9rem',
            fontWeight: 500
        },
        plusMinus: {
            color: '#0A54A2'
        },
        vtoSidePanelSection: {
            height: 'calc(100vh - 57px)',
            backgroundColor: '#FFFFFF',
            padding: 15,
            overflow: 'hidden',
            width: '100%',
        },

        tableRow: {
            verticalAlign: "top"
        },
        cellHeaders: {
            width: '60px',
            border: '1px solid #e0e0e0',
            height: '40px',
            padding: '5px 0 0 0 !important',
            fontSize: 'medium',
            textAlign: 'center',
            fontVariant: 'oldstyle-nums',
            margin: '10px',
            background: 'white'
        },
        cellDays: {
            width: '100px',
            border: '1px solid #e0e0e0',
            height: '160px',
            padding: '5px 0 0 0 !important',
            fontSize: 'medium',
            textAlign: 'center',
            fontVariant: 'oldstyle-nums',
            margin: '10px',
            background: 'white'
        },
        employeeShift: {
            backgroundColor: 'rgba(10, 84, 162, 0.12)',
            borderRadius: 2,
            opacity: 1,
            margin: '1%',
        },
        mainContent: {
            margin: '0 15px',
            height: 'calc(100vh - 65px)',
            display: 'flex'
        },
        flex: {
            display: 'flex',
        },
        arrowButton: {
            minWidth: 0,
            width: 30,
            height: 30,
        },
        button: {
            color: '#3A3A3A',
            border: '1px solid #E6EDF5',
            borderRadius: 2,
            marginRight: 5,
            marginLeft: 5,
            paddingLeft: 10,
            paddingRight: 10,
        },
        refreshButton: {
            minWidth: 0,
            padding: 11,
        },
        root: {
            width: '100%',
            marginTop: theme.spacing(3),
            marginBottom: '-13px'
        },
        tableWrapper: {
            overflow: 'scroll',
            position: 'fixed',
            bottom: 0,
            zIndex: '1',
        },
        tableFixed: {
            width: '100%',
            margin: 'auto',
            borderCollapse: 'separate',
            borderSpacing: '0'
        },
        gotSkills: {
            color: 'orange'
        },
        isOT: {
            color: 'red'
        },
        isNotOT: {
            color: 'black'
        },
        input: {
            height: '36px',
            textAlign: 'right'
        },
        noMaxWidth: {
            maxWidth: 'none',
        },
        buttonStatus: {
            borderRadius: '20px',
            margin: theme.spacing(),
            minWidth: '120px'
        },
        rollout: {
            justifyContent: 'flex-end'
        },
        header: {
            display: 'inline-flex',
            marginTop: '20px',
            marginBottom: '10px',
            padding: '0 0 5px 0px',
            width: '100%',
        },
        flexButtonStatus: {
            flex: 1,
            marginLeft: '20px',
            marginTop: '20px',
            maxWidth: '120px'
        },
        actionType:
        {
            background: '#48D96029 0% 0% no-repeat padding-box',
            borderRadius: '2px',
            opacity: '1',
        },
        flexWrapper: {
            flex: 1
        },
        headerTwo: {
            display: 'inline-flex',
            marginTop: '15px',
            marginBottom: '15px',
            padding: '0 0 5px 0px',
            width: '100%',
        },
        headerItem: {
            minWidth: '120px',
            margin: '0 5px'
        },
        alignFont: {
            display: 'flex'
        },
        effectiveDate: {
            marginRight: '8%',
            padding: '5px 0px 5px 0px',
        },
        Typo: {
            padding: '5px 0px 5px 0px',
        },
        pausedStatus: {
            borderColor: 'darkorange',
            color: 'darkorange'
        },
        stopStatus: {
            borderColor: 'red',
            color: 'red'
        },
        activeStatus: {
            borderColor: 'green',
            color: 'green'
        },
        regularStatus: {
            borderColor: 'rgba(0, 0, 0, 0.26)',
            color: 'black'
        },
        textField: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
            padding: '0px 110px 5px 0px'
        },
        dense: {
            marginTop: 16,
        },
        groupTextField: {
            border: '1px solid #a5a5a5',
            borderRadius: '4px',
            padding: '0px 5px 10px 5px',
            display: 'grid'
        },
        notes: {
            minHeight: '100px',
            width: "100%",
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
        },
        ButtonAction: {
            margin: '8px',
            borderColor: '#E6EDF5',
            '&:disabled': {
                border: 0
            }
        },
        buttonCancel: {
            marginLeft: '15px',
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #E6EDF5',
            borderRadius: '2px',
            opacity: '1',
        },
        buttonSubmit: {
            backgroundColor: '#1a518a',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '4px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 15px',
            opacity: '1',
            '&:hover': {
                backgroundColor: 'rgb(18,56,96)',
                opacity: '70%'
            },
            '&.Mui-disabled': {
                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                '& > span > p': {
                    color: 'rgba(0, 0, 0, 0.26)'
                }
            }
        },
        buttonDisabled: {
            backgroundColor: '#6d88a3',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '4px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
        },
        cards: {
            boxShadow: 'none',
            border: '1px solid #E6EDF5',
            overflow: 'visible',
        },
        cardHeader: {
            borderBottom: '1px solid #e6edf5',
        },
        numberedStepContainerCardHeader: {
            borderBottom: '1px solid #e6edf5',
            padding: '8px 16px',
            '&action': {
                display: 'flex',
                
            }
        },
        numberedStepContainerCardAction: {
            height: '40px',
        },
        numberedStepContainerCardContent: {
            '&:last-child': {
                paddingBottom: '16px',
            },
        },
        sendToPrivateToggleCardContent: {
            '&:last-child': {
                padding: '16px 16px 7px 16px',
            },
        },
        RejectButton:
        {
            "background": "#FFFFFF 0% 0% no-repeat padding-box",
            "border": "1px solid #AFC6DF",
            marginLeft: "1vw",
            marginBottom: "1vw",
            textAlign: "center",
            font: "Medium 16px/18px Roboto",
            letterSpacing: "0",
            opacity: "1",
            borderRadius: "2px",
        },
        buttonProposal: {
            backgroundColor: '#0A54A2',
            width: "100%",
            background: '#0A54A2 0% 0% no-repeat padding-box',
            boxShadow: '0px 0px 12px #0A54A229',
            border: '1px solid #0A54A2',
            borderRadius: '2px',
            opacity: '1',
            '&:hover': {
                backgroundColor: '#0454A2',
                opacity: '70%'
            }
        },
        buttonPrivate: {
            color: 'white',
            background: '#FF7A59',
            marginLeft: '12px',
            boxShadow: '0px 0px 12px #FF7A5929',
            border: '1px solid #FF7A59',
            borderRadius: '2px',
            '&:hover': {
                backgroundColor: '#FF7A59',
                opacity: '70%'
            }
        },
        labelButton: {
            textTransform: 'capitalize'
        },
        disabledIcon: {
            color: '#b9b9b9'
        },
        labelHeader: {
            color: '#A9A9A9',
            fontWeight: 100,
            fontSize: '12px',
            display: 'block'
        },
        infoHeader: {
            fontWeight: 500,
            color: '#545454',
            fontSize: '13px'
        },
        verticalAlign: {
            verticalAlign: 'middle'
        },
        buttonRectangleChipsCover:
        {
            pointerEvents: 'none',
            paddingLeft: '6px',
            verticalAlign: 'middle',
            background: '#48D96029 0% 0% no-repeat padding-box',
            borderRadius: '2px',
            opacity: '1',
        },
        buttonRectangleChipsRequest:
        {
            pointerEvents: 'none',
            paddingLeft: '6px',
            verticalAlign: 'middle',
            background: '#0A54A229 0% 0% no-repeat padding-box',
            borderRadius: '2px',
            opacity: '1',
        },
        gridPadding:
        {
            paddingTop: '25px'
        },
        gridRectangleChipsTextCover:
        {
            textTransform: 'none',
            textAlign: 'center',
            font: '12px/14px Roboto',
            letterSpacing: '0',
            color: '#48D960',
            opacity: '1',
        },
        gridRectangleChipsTextRequest:
        {
            textTransform: 'none',
            textAlign: 'center',
            font: '12px/14px Roboto',
            letterSpacing: '0',
            color: '#0A54A2',
            opacity: '1',
        },
        SideBar: {
            minWidth: '470px',
            maxWidth: '1050px',
            backgroundColor: '#F8FAFC',
            height: '100%',
        },
        SideBarTitle:
        {
            fontSize: '16px',
            fontFamily: 'Montserrat, Regular',
            letterSpacing: '0',
            color: '#3A3A3A',
            opacity: '1',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        SideBarCancelText:
        {
            textTransform: 'none',
            textAlign: 'left',
            font: 'Bold 12px/18px Roboto',
            letterSpacing: '0',
            color: '#0A54A2',
            opacity: '1',
        },
        SidePanelButtonText:
        {
            textTransform: 'uppercase',
            font: '14px Roboto',
            color: '#FFFFFF',
            fontWeight: 'Medium',

        },
        SidePanelButtonOrangeText:
        {
            textTransform: 'uppercase',
            font: '14px Roboto',
            fontWeight: 'Medium',
            color: '#F46F6F'
        },
        SideBarSubmitText:
        {
            textTransform: 'none',
            textAlign: 'left',
            font: 'Bold 12px/18px Roboto',
            fontFamily: 'Roboto',
            letterSpacing: '0',
            color: '#FFFFFF',
            opacity: '1'
        },
        sidebarExtendedContainer: {
            width: '1050px',
            margin: 0,
            height: 'calc(100% - 57px)',
        },
        sidebarLeftContainer: {
            backgroundColor: '#F8FAFC',
            overflow: 'auto',
            height: '100%'
        },
        sidebarRightContainer: {
            borderLeft: '1px solid #E6EDF5',
            backgroundColor: '#FFFFFF',
            overflow: 'auto',
            height: 'calc(100vh - 114px)',
        },
        sidebarContainer: {
            width: '470px'
        },
        sidebarActionContainer: {
            top: 57,
            boxShadow: "0px -1px 5px #cecece",
            width: "100%",
            backgroundColor: '#ffffff',
            height: 57,
            padding: 14,
            zIndex: 1,
            display: "flex",
            justifyContent: "flex-end",
        },
        selectWidth: {
            width: '135px'
        },
        detailsCard:
        {
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #E6EDF5',
            borderRadius: '4px',
            opacity: '1',
        },
        detailsCardTitle:
        {
            marginTop: '15px',
            fontSize: '12px',
            fontWeight: 'bold',
            textAlign: 'left',
            font: 'Regular 12px/18px Montserrat',
            letterSpacing: '0',
            color: '#3A3A3A',
            opacity: '1',
        },
        detailsCardName:
        {
            textAlign: 'left',
            font: 'Regular 14px/17px Roboto',
            letterSpacing: '0',
            color: '#878787',
            opacity: '1',
        },
        detailsCardValue:
        {
            fontWeight: 'bold',
            fontSize: '14px',
            textAlign: 'left',
            font: 'Medium 14px/17px Roboto',
            letterSpacing: '0',
            color: '#3A3A3A',
            opacity: '1',
        },
        detailsCardEmployeeName:
        {
            fontWeight: 'bold',
            fontSize: '12px',
            textAlign: 'left',
            font: 'Medium 12px/14px Roboto',
            letterSpacing: '0',
            color: '#3A3A3A',
            opacity: '1',
        },
        detailsCardEmployeeId:
        {
            textAlign: 'left',
            font: 'Regular 10px/13px Roboto',
            fontSize: '10px',
            letterSpacing: '0',
            color: '#878787',
            opacity: '1',
        },
        shiftNameText: {
            paddingTop: '25px',
            textAlign: 'left',
            font: 'Bold  20px/18px Montserrat',
            letterSpacing: '0',
            color: '#3A3A3A',
            opacity: '1',
        },
        shiftDate: {
            textTransform: 'capitalize',
            textAlign: 'left',
            font: 'Medium 14px/17px Roboto',
            letterSpacing: '0',
            color: '#545454',
            opacity: '1',
        },
        shiftDateTime: {
            textAlign: 'left',
            font: 'Medium 14px/17px Roboto',
            letterSpacing: '0',
            color: '#545454',
            opacity: '1',
        },
        superSelect: {
            width: '155PX',
            '& .reactSelect__indicators': {
                position: 'absolute',
                height: '30px',
                right: '0px !important'
            }
        },
        timePadding: {
            paddingTop: '25px',
            paddingBottom: '25px'
        },
        toolTipContainer: {
            width: 'inherit'
        },
        proposalContainer: {
            width: '960px',
            overflow: 'hidden',
        },
        h1: {
            display: 'flex',
            fontSize: '1.25rem',
            fontFamily: 'Roboto',
            fontWeight: '700',
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: '8px',
            lineHeight: '1.5',
            letterSpacing: '0.00938em'
        },
        preferredDateNoPadding: {
            padding: '0px 16px',
        },
        boxShadow: {
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
        },
        recipientNames: {
            fontSize: '0.875rem',
            fontFamily: 'Roboto',
            fontWeight: '400',
            lineHeight: '1.43',
            letterSpacing: '0.01071em'
        },
        sidePanelStepHeader: {
            fontSize: '0.875rem',
            fontFamily: 'Roboto',
            fontWeight: '400',
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: '16px',
            lineHeight: '1.43',
            letterSpacing: '0.01071em'
        },
        selectWrapper: {
            marginBottom: 0,
        },
    }
}


export const ManagerDashboardSettingFormStyles = theme => ({
    headerStyle: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '51px'
    },
    requestHeaderStyle: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
    },
    NOOVERFLOW: {
        overflow: 'hidden !important'
    },
    textField: {
        padding: '13px'
    },
    numberContainer: {
        display: 'flex',
        alignItems: 'center',
        padding: '15px 0px',
    },
    formContainer: {
        padding: '15px',
    },
    formContainerReadOnly: {
        padding: '15px',
        pointerEvents: 'none'
    },
    HeaderForm: {
        color: '#767676',
        borderBottom: '1px solid #E6EDF5',
        margin: '-15px',
        padding: '15px',
        backgroundColor: 'white',
    },
    title: {
        fontSize: '17px',
        border: '1px solid #E6EDF5',
        width: 'fit-content',
        padding: '10px',
        borderRadius: '25px',
        display: 'inline-flex',
        fontWeight: 400,
    },
    cards: {
        marginTop: '5%',
        boxShadow: 'none',
        border: '1px solid #E6EDF5',
        overflow: 'visible',
    },
    addIcon: {
        color: '#6EA0D7'
    },
    cardHeader: {
        borderBottom: '1px solid #e6edf5',
    },
    avatar: {
        color: '#9DBAD9',
        backgroundColor: '#E6EDF5',
        width: '30px',
        height: '30px',
        fontSize: 'smaller',
    },
    maxLength: {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    formControlLabel: {
        fontSize: 12,
        color: 'grey'
    },
    requestSubtypeInput: {
        marginTop: '20px'
    },
    inputNumber: {
        width: 60
    },
    classLabel: {
        marginTop: -22,
        position: 'absolute',
        color: '#878787',
        fontSize: 12
    },
    closeIcon: {
        transform: "scale(0.68)",
        float: "right",
        cursor: "pointer"
    },
    divider: {
        marginTop: 5,
        marginBottom: 5
    },
    requestPeriodLabelWrapper: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    requestPeriodLabel: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },


    drp: {
        width: 'max-content'
    },
    drpButton: {
        width: '100%',
        height: '100%',
        border: '1px solid #E6EDF5',
        padding: '10px',
        margin: '5px 0px',
        marginTop: -15,
        justifyContent: 'flex-start !important'
    },
    calendarIcon: {
        marginRight: '3px',
        color: '#357ebd',
    },
    containerStylesContainer: {
        marginLeft: 'auto',

    },
    chevronIcon: {
        marginLeft: '7px',
        color: '#357ebd',
    },
    containerStyles: {
        width: '100%',
        // height: '44px'
    },
    labelWrapper: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
    },
    label: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
        width: '160px'
    },
    dateContainer: {
        width: '100%'
    },
    foreverCheck: {
        marginTop: -10,
        marginLeft: -9,
    },
    error: {
        borderColor: 'red'
    },
    errorDate: {
        margin: 0,
        textAlign: 'right',
        height: 0
    },
    checkLabel: {
        fontSize: 12
    },
    calendarVisible: {
        display: 'block',
        width: '100%',
    },  
    calendarHidden: {
        visibility: 'hidden',
        height: 0,
        overflow: 'hidden',
    },
})